import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=3f4d38bc"
import script from "./agree.vue?vue&type=script&lang=js"
export * from "./agree.vue?vue&type=script&lang=js"
import style0 from "./agree.vue?vue&type=style&index=0&id=3f4d38bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports